import {myLinks} from "@/lib/routes/myLinks";
import {catNipNav, howToVideosNav, rolesNav, userNav} from "@/lib/routes/nav";
import {Catnip, HowToVideos, Roles, User} from "./icons";
import {Link} from "@/theme/ui";

const generalGroup = [
    ...userNav,
    ...rolesNav,
    ...catNipNav,
    ...howToVideosNav,
]

const permissionsMenuGroup = (links) =>{
    const permissions = []

    links.map((link)=>{
        link.permissions.map((permissionLink)=>{
            if (!permissions.includes(permissionLink)){
                permissions.push(permissionLink)
            }
        })
    })

    return permissions
}

export const menuItems = [
    getItem({label: 'General', key: 'general_group', type: 'group', permissions: permissionsMenuGroup(generalGroup), children: [
            getItem({...myLinks.getLink('users.index'), icon: <User />}),
            getItem({ ...myLinks.getLink('roles.index'), icon: <Roles />}),
            getItem({ ...myLinks.getLink('catnip.index'), icon: <Catnip />}),
            getItem({ ...myLinks.getLink('howToVideos.index'), icon: <HowToVideos />}),
        ]}),
    // getItem({label: 'Test', key: 'test_group', children: [
    //         getItem({...myLinks.getLink('test')}),
    //         getItem({...myLinks.getLink('test.dynamic', {id: 'dynamic'})}),
    //     ]}),
]

function getItem({label, key, icon, children, type, url, permissions = []}) {
    return {
        key,
        icon: (
            <div className={'ant-menu-item-icon'}>
                {icon}
            </div>
        ),
        children,
        label: url
            ? (
                <>
                    <Link href={url}>
                        {label}
                    </Link>
                </>
            )
            : label
        ,
        type,
        permissions,
        theme: 'light',
    };
}
